var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/MemberProfile/MemberProfile.jinja"] = require( "front/components/MemberProfile/MemberProfile.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/MembersPopup/MembersPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/MembersPopup/MembersPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/MembersPopup/MembersPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/MemberProfile/MemberProfile.jinja", false, "assets/app/front/pages/MembersPopup/MembersPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "MemberProfile")) {
var t_10 = t_7.MemberProfile;
} else {
cb(new Error("cannot import 'MemberProfile'")); return;
}
context.setVariable("MemberProfile", t_10);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"MembersPopup\">\n        <div class=\"MembersPopup-content\">\n            ";
output += runtime.suppressValue((lineno = 8, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfile"), "MemberProfile", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "popup"),"isOwner": ((lineno = 8, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getLoggedId"), "getLoggedId", context, [runtime.contextOrFrameLookup(context, frame, "request")])) == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"id"))})])), env.opts.autoescape);
output += "\n        </div>\n    </div>\n\n    <script type=\"application/ld+json\">\n\t{\n\t  \"@context\": \"https://schema.org\",\n\t  \"@type\": \"ProfilePage\",\n\t  \"mainEntity\": {\n\t    \"@type\": \"Person\",\n\t    \"name\": \"";
output += runtime.suppressValue(env.getFilter("json_escape").call(context, (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"firstName") + " " + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"lastName"))), env.opts.autoescape);
output += "\",\n\t    \"image\": \"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"userpic")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"userpic")),"w400_url")) {
output += runtime.suppressValue(env.getFilter("json_escape").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"userpic")),"w400_url")), env.opts.autoescape);
;
}
else {
output += runtime.suppressValue(env.getFilter("json_escape").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"userpic")),"tempImg")), env.opts.autoescape);
;
}
;
}
else {
output += runtime.suppressValue(env.getFilter("json_escape").call(context, "https://assets.adg.org/static/img/logo-share-large.png"), env.opts.autoescape);
;
}
output += "\",\n\t    \"url\": \"";
output += runtime.suppressValue(env.getFilter("json_escape").call(context, (lineno = 20, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "get_current_url"), "get_current_url", context, [runtime.contextOrFrameLookup(context, frame, "request")]))), env.opts.autoescape);
output += "\",\n\t    \"jobTitle\": \"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"classificationsString")) {
output += runtime.suppressValue(env.getFilter("json_escape").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"classificationsString")), env.opts.autoescape);
;
}
output += "\",\n\t    \"description\": \"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"bio")) {
output += runtime.suppressValue(env.getFilter("json_escape").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"bio")), env.opts.autoescape);
;
}
output += "\"\n\t  },\n\t  \"url\": \"";
output += runtime.suppressValue(env.getFilter("json_escape").call(context, (lineno = 24, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "get_current_url"), "get_current_url", context, [runtime.contextOrFrameLookup(context, frame, "request")]))), env.opts.autoescape);
output += "\"\n\t}\n\t</script>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/MembersPopup/MembersPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MembersPopup/MembersPopup.jinja
// module id = 550
// module chunks = 0